// All UI copy is final, client-facing Polish content — do not translate.

export const ACCENTS = {
  yellow: "#F3DD6D",
  green: "#78BD70",
  blue: "#44A8C6",
  purple: "#C1A7E2",
  pink: "#F59BBB",
  red: "#F59BBB",
};

export const NAV_LINKS = [
  { label: "Filary", href: "#values" },
  { label: "Kampania", href: "#metrics" },
  { label: "Zabawa", href: "#playground" },
];

export const CAPS = {
  red: "https://static.prod-images.emergentagent.com/jobs/f53d2177-a756-4863-8791-9f0d1c723fb1/images/90be615ccee19a28fb5bd42f25159715d3d1a3f4e0802f3a96caa923eefde4dd.png",
  blue: "https://static.prod-images.emergentagent.com/jobs/f53d2177-a756-4863-8791-9f0d1c723fb1/images/ab58586974665505d8feeede4ea1d83b3e74d4f652a23099a534ef8c0b63832e.png",
  yellow: "https://static.prod-images.emergentagent.com/jobs/f53d2177-a756-4863-8791-9f0d1c723fb1/images/bf24cc14470181a5b39e1680f1d37599a7d98cf576cb02e543ec19ae70f71581.png",
  green: "https://static.prod-images.emergentagent.com/jobs/f53d2177-a756-4863-8791-9f0d1c723fb1/images/2201cf84ff0840a15a43a143f3929ea4d076fa32f9f36ac8a344dc948eb57281.png",
};

export const SIMPLE_CAPS = {
  red: "/caps/simple_red.png",
  blue: "/caps/simple_blue.png",
  yellow: "/caps/simple_yellow.png",
  green: "/caps/simple_green.png",
};

export const IMAGES = {
  heroCap: "/caps/mus.png",
  nostalgia1: "https://images.unsplash.com/photo-1485783522162-1dbb8ffcbe5b?auto=format&fit=crop&w=1000&q=80",
  nostalgia2: "https://images.unsplash.com/photo-1631032024590-140cc8dd4b32?auto=format&fit=crop&w=800&q=80",
  metrics: "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?auto=format&fit=crop&w=1600&q=80",
};

export const STEPS = [
  { n: "01", title: "Zbieraj", body: "Każdy mus to nowy element kolekcji.", color: ACCENTS.red },
  { n: "02", title: "Łącz", body: "Zakrętki pasują do siebie jak klocki.", color: ACCENTS.blue },
  { n: "03", title: "Buduj", body: "Im więcej OWOCAPS, tym większe konstrukcje.", color: ACCENTS.yellow },
  { n: "04", title: "Wymyślaj", body: "Nie ma instrukcji. Jest fantazja.", color: ACCENTS.green },
];

export const CONFIG_STOPS = [
  { count: 3, msg: "Pierwszy klik. Pierwszy pomysł." },
  { count: 6, msg: "Mała konstrukcja. Duża satysfakcja." },
  { count: 12, msg: "Tu zaczyna się zabawa." },
  { count: 24, msg: "Możesz już budować całe historie." },
  { count: 50, msg: "Witaj w świecie OWOCAPS." },
];

export const BIG_IDEA_STATS = [
  {
    value: 5.5,
    decimals: 1,
    suffix: " godz.",
    color: ACCENTS.red,
    desc: "tyle czasu dziennie dzieci 8-12 lat spędzają przed ekranem",
    source: "Źródło: Common Sense Media, 2025",
  },
  {
    value: 2,
    suffix: "×",
    color: ACCENTS.blue,
    desc: "większe ryzyko problemów z koncentracją przy nadmiarze ekranów",
    source: "Źródło: przegląd systematyczny nt. ADHD i ekranów",
  },
  {
    value: 68,
    suffix: "%",
    color: "#0A0A0A",
    desc: "rodziców martwi się spadkiem zabawy analogowej u dzieci",
    source: "Źródło: CBOS / Instytut Cyfrowego Obywatelstwa",
  },
  {
    value: 40,
    suffix: "%",
    color: ACCENTS.green,
    desc: "mniej swobodnej zabawy niż pokolenie ich rodziców",
    source: "Źródło: American Psychological Association (APA)",
  },
];

export const BIG_IDEA_FOOTNOTE =
  "* Dane prezentowane poglądowo na podstawie wskazanych źródeł (Common Sense Media 2025, Instytut Cyfrowego Obywatelstwa, CBOS, przegląd systematyczny nt. ADHD i ekranów, APA nt. zabawy swobodnej). Finalne wartości i przypisy do zatwierdzenia przez markę.";

export const MARQUEE_ITEMS = [
  { type: "text", value: "ŁĄCZ", filled: true },
  { type: "dot", color: ACCENTS.red },
  { type: "text", value: "BUDUJ", filled: false },
  { type: "dot", color: ACCENTS.blue },
  { type: "text", value: "ZBIERAJ", filled: true },
  { type: "dot", color: ACCENTS.yellow },
  { type: "text", value: "ODKRYWAJ", filled: false },
  { type: "dot", color: ACCENTS.green },
];

export const METRICS = [
  { value: 15, suffix: "M+", color: ACCENTS.pink, label: "Zasięg kampanii" },
  { value: 5, suffix: "", color: ACCENTS.blue, label: "Top Influencerów" },
  { value: 360, suffix: "°", color: "#0A0A0A", label: "Wsparcie mediowe", spin: true },
];

export const AMBASSADORS = [
  {
    name: "Gawronek",
    color: ACCENTS.pink,
    initial: "G",
    photo: "https://customer-assets.emergentagent.com/job_caps-collection-hub/artifacts/ihf15trw_Obraz%202.07.2026%2C%20godz.%2009.32.png",
    igCount: "530K",
    ttCount: "1,4 mln",
    igHandle: "@gawronek",
    ig: "IG: 530K obserwujących · ER 2,31%",
    tt: "TT: 1,4 mln obserwujących · 55,8 mln polubień",
    topStat: "55,8 mln",
    topLabel: "polubień na TikToku",
  },
  {
    name: "Eliza Macudzińska",
    color: ACCENTS.blue,
    initial: "E",
    photo: "https://customer-assets.emergentagent.com/job_caps-collection-hub/artifacts/c6rtr5c5_Obraz%202.07.2026%2C%20godz.%2009.30.png",
    igCount: "416K",
    ttCount: "817,7K",
    igHandle: "@eliza_macudzinska",
    ig: "IG: 416K obserwujących · ER 6,42%",
    tt: "TT: 817,7K obserwujących · 40,6 mln polubień",
    topStat: "6,42%",
    topLabel: "wskaźnik zaangażowania (ER) na IG",
  },
  {
    name: "Borys Ryskala",
    color: ACCENTS.yellow,
    initial: "B",
    photo: "https://customer-assets.emergentagent.com/job_caps-collection-hub/artifacts/rva2agr0_Obraz%202.07.2026%2C%20godz.%2009.33.png",
    igCount: "338K",
    ttCount: "515,7K",
    igHandle: "@borys_ryskala",
    ig: "IG: 338K obserwujących · ER 1,6%",
    tt: "TT: 515,7K obserwujących · 19 mln polubień",
    topStat: "515,7K",
    topLabel: "obserwujących na TikToku",
  },
  {
    name: "Dominik Rupiński",
    color: ACCENTS.green,
    initial: "D",
    photo: "https://customer-assets.emergentagent.com/job_caps-collection-hub/artifacts/h1pg2qj5_7e22d16b-fccb-496d-82c2-a7b7e8525077.jpg",
    igCount: "1,27 mln",
    ttCount: "4,2 mln",
    igHandle: "@dominikrupinski",
    igUrl: "https://www.instagram.com/dominikrupinski/",
    ig: "IG: ~1,27 mln obserwujących",
    tt: "TT: ~4,2 mln obserwujących · 222,8 mln polubień",
    topStat: "222,8 mln",
    topLabel: "łącznych polubień na TikToku",
  },
  {
    name: "Emilia Kostyk",
    color: ACCENTS.purple,
    initial: "E",
    photo: "https://customer-assets.emergentagent.com/job_caps-collection-hub/artifacts/yyyi3bo3_0cd9bee2-feda-40ac-935f-fef967fd8d97.jpg",
    igCount: "138K",
    ttCount: "513K",
    igHandle: "@emilka_kostyk",
    igUrl: "https://www.instagram.com/emilka_kostyk/",
    ig: "IG: 138 tys. obserwujących",
    tt: "TT: ~513 tys. obserwujących · 19,8 mln polubień",
    topStat: "19,8 mln",
    topLabel: "łącznych polubień na TikToku",
  },
];
